import { useEffect } from "react";
import { motion } from "framer-motion";

export default function Preloader({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2300);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[90] bg-ivory flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.img
        src="/assets/logo.png"
        alt="Fantasy Dancefloors"
        className="w-64 sm:w-80"
        initial={{ opacity: 0, scale: 0.92, filter: "blur(8px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.div
        className="mt-8 h-px bg-gold"
        initial={{ width: 0 }}
        animate={{ width: 180 }}
        transition={{ duration: 1.4, delay: 0.5, ease: "easeInOut" }}
      />
      <motion.p
        className="mt-5 text-[11px] tracking-[0.5em] uppercase text-ink/50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9, duration: 0.8 }}
      >
        Unrolling the magic
      </motion.p>
    </motion.div>
  );
}
